/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddMeasuresRequest {
  /** @format uuid */
  UserId: string
  /** @format int32 */
  DeviceId?: number | null
  /**
   *
   *
   * 1 = Google
   *
   * 2 = Apple
   *
   * 3 = Tenovi
   *
   * 4 = Life365
   */
  VendorType?: DeviceVendorType
  /**
   *
   *
   * 1 = Temperature
   *
   * 2 = BloodPressureSystolic
   *
   * 3 = BloodPressureDiastolic
   *
   * 4 = GlucoseLevel
   *
   * 5 = Pulse
   *
   * 6 = OxygenSaturation
   *
   * 7 = Weight
   *
   * 8 = Height
   *
   * 9 = RestingPulse
   *
   * 10 = PerfusionIndex
   *
   * 11 = PeakExpiratoryFlow
   *
   * 12 = ForcedExpiratoryVolume
   */
  MeasureId: MeasureType
  /**
   *
   *
   * 1 = DegreesCelsius
   *
   * 2 = DegreesFahrenheit
   *
   * 3 = BeatsPerMinute
   *
   * 4 = MillimetersOfMercury
   *
   * 5 = Percentage
   *
   * 6 = MillimolesPerLiter
   *
   * 7 = Kilogram
   *
   * 8 = Pound
   *
   * 9 = Foot
   *
   * 10 = Inch
   *
   * 11 = Meter
   *
   * 12 = Centimeter
   *
   * 13 = MilligramsPerDeciliter
   *
   * 14 = LitersPerMinute
   *
   * 15 = Liters
   */
  MeasureUnitId: MeasureUnitsType
  /** @format double */
  Value: number
  /** @format date-time */
  CreatedOn?: string | null
}

export interface ApiErrorResponse {
  Error: Error
}

export interface ClearLife365DeviceModel {
  /** @minLength 1 */
  DeviceSerialNumber: string
  /** @format uuid */
  UserId: string
}

export interface CreateDeviceRequest {
  /** @maxLength 100 */
  ExternalId: string
  /** @maxLength 100 */
  Name: string
  /** @format int32 */
  UserId?: number | null
  /**
   *
   *
   * 1 = Google
   *
   * 2 = Apple
   *
   * 3 = Tenovi
   *
   * 4 = Life365
   */
  VendorType: DeviceVendorType
  ProgramId?: string | null
  /**
   *
   *
   * 10 = BPM
   *
   * 11 = PulseOx
   *
   * 12 = Glucometer
   *
   * 13 = Scale
   *
   * 14 = Thermometer
   *
   * 15 = Watch
   *
   * 17 = PeakFlowMeter
   */
  TenoviSensorCodeType?: TenoviSensorCode
  /**
   *
   *
   * 1 = TenoviBpmS
   *
   * 2 = TenoviBpmSSignature
   *
   * 3 = TenoviBpmL
   *
   * 4 = TenoviBpmLSignature
   *
   * 5 = TenoviPulseOx
   *
   * 6 = TenoviScale
   *
   * 7 = TenoviGlucometer
   *
   * 8 = TenoviWatch
   */
  TenoviDeviceNameType?: TenoviDeviceNameType
  TenoviHardwareUuid?: string | null
}

/**
 *
 *
 * 1 = Life365ProgramId
 *
 * 2 = TenoviSensorCode
 * @format int32
 */
export enum DeviceAddAttributeTypeEnum {
  Life365ProgramId = 1,
  TenoviSensorCode = 2,
}

export interface DeviceAttributeViewModel {
  /** @format int32 */
  Id: number
  /** @format int32 */
  DeviceId: number
  /**
   *
   *
   * 1 = Life365ProgramId
   *
   * 2 = TenoviSensorCode
   */
  AttributeTypeId: DeviceAddAttributeTypeEnum
  Value: string
}

/**
 *
 *
 * 1 = MultiPurposeHealthDevice
 *
 * 2 = Thermometer
 *
 * 3 = PressureMonitor
 *
 * 4 = SugarMonitor
 *
 * 5 = Pulsemeter
 *
 * 6 = PulseOximeter
 *
 * 7 = Scale
 *
 * 8 = Stadiometer
 *
 * 9 = PeakFlowMeter
 *
 * 10 = Spirometer
 * @format int32
 */
export enum DeviceCategoryType {
  MultiPurposeHealthDevice = 1,
  Thermometer = 2,
  PressureMonitor = 3,
  SugarMonitor = 4,
  Pulsemeter = 5,
  PulseOximeter = 6,
  Scale = 7,
  Stadiometer = 8,
  PeakFlowMeter = 9,
  Spirometer = 10,
}

/**
 *
 *
 * 1 = Google
 *
 * 2 = Apple
 *
 * 3 = Tenovi
 *
 * 4 = Life365
 * @format int32
 */
export enum DeviceVendorType {
  Google = 1,
  Apple = 2,
  Tenovi = 3,
  Life365 = 4,
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface GetDeviceResponse {
  /** @format int32 */
  Id: number
  IsDeleted: boolean
  /** @format date-time */
  CreatedOn?: string | null
  ExternalId: string
  Name: string
  IsDisabled: boolean
  /** @format uuid */
  UserId?: string | null
  /** @format date-time */
  DisabledOn?: string | null
  /** @format date-time */
  DeletedOn?: string | null
  /**
   *
   *
   * 1 = Google
   *
   * 2 = Apple
   *
   * 3 = Tenovi
   *
   * 4 = Life365
   */
  VendorType: DeviceVendorType
  /**
   *
   *
   * 1 = MultiPurposeHealthDevice
   *
   * 2 = Thermometer
   *
   * 3 = PressureMonitor
   *
   * 4 = SugarMonitor
   *
   * 5 = Pulsemeter
   *
   * 6 = PulseOximeter
   *
   * 7 = Scale
   *
   * 8 = Stadiometer
   *
   * 9 = PeakFlowMeter
   *
   * 10 = Spirometer
   */
  CategoryType: DeviceCategoryType
  /** @format int32 */
  DeviceTypeId: number
  DeviceAddAttributes: DeviceAttributeViewModel[]
}

export interface GetDeviceTypesMeasureResponse {
  /**
   *
   *
   * 1 = Temperature
   *
   * 2 = BloodPressureSystolic
   *
   * 3 = BloodPressureDiastolic
   *
   * 4 = GlucoseLevel
   *
   * 5 = Pulse
   *
   * 6 = OxygenSaturation
   *
   * 7 = Weight
   *
   * 8 = Height
   *
   * 9 = RestingPulse
   *
   * 10 = PerfusionIndex
   *
   * 11 = PeakExpiratoryFlow
   *
   * 12 = ForcedExpiratoryVolume
   */
  Id: MeasureType
  Name: string
}

export interface GetDeviceTypesResponse {
  /** @format int32 */
  Id: number
  Name: string
  /**
   *
   *
   * 1 = MultiPurposeHealthDevice
   *
   * 2 = Thermometer
   *
   * 3 = PressureMonitor
   *
   * 4 = SugarMonitor
   *
   * 5 = Pulsemeter
   *
   * 6 = PulseOximeter
   *
   * 7 = Scale
   *
   * 8 = Stadiometer
   *
   * 9 = PeakFlowMeter
   *
   * 10 = Spirometer
   */
  CategoryId: DeviceCategoryType
  /**
   *
   *
   * 1 = Google
   *
   * 2 = Apple
   *
   * 3 = Tenovi
   *
   * 4 = Life365
   */
  VendorId: DeviceVendorType
  AvailableMeasures: GetDeviceTypesMeasureResponse[]
}

export interface GetMeasureResponse {
  /**
   *
   *
   * 1 = Temperature
   *
   * 2 = BloodPressureSystolic
   *
   * 3 = BloodPressureDiastolic
   *
   * 4 = GlucoseLevel
   *
   * 5 = Pulse
   *
   * 6 = OxygenSaturation
   *
   * 7 = Weight
   *
   * 8 = Height
   *
   * 9 = RestingPulse
   *
   * 10 = PerfusionIndex
   *
   * 11 = PeakExpiratoryFlow
   *
   * 12 = ForcedExpiratoryVolume
   */
  MeasureId: MeasureType
  /**
   *
   *
   * 1 = DegreesCelsius
   *
   * 2 = DegreesFahrenheit
   *
   * 3 = BeatsPerMinute
   *
   * 4 = MillimetersOfMercury
   *
   * 5 = Percentage
   *
   * 6 = MillimolesPerLiter
   *
   * 7 = Kilogram
   *
   * 8 = Pound
   *
   * 9 = Foot
   *
   * 10 = Inch
   *
   * 11 = Meter
   *
   * 12 = Centimeter
   *
   * 13 = MilligramsPerDeciliter
   *
   * 14 = LitersPerMinute
   *
   * 15 = Liters
   */
  MeasureUnitId: MeasureUnitsType
  /** @format double */
  Value: number
  /** @format date-time */
  CreatedOn: string
}

export interface IOTDeviceViewModel {
  /** @format int32 */
  Id: number
  Description: string
  /**
   *
   *
   * 1 = MultiPurposeHealthDevice
   *
   * 2 = Thermometer
   *
   * 3 = PressureMonitor
   *
   * 4 = SugarMonitor
   *
   * 5 = Pulsemeter
   *
   * 6 = PulseOximeter
   *
   * 7 = Scale
   *
   * 8 = Stadiometer
   *
   * 9 = PeakFlowMeter
   *
   * 10 = Spirometer
   */
  CategoryType: DeviceCategoryType
  /**
   *
   *
   * 1 = Google
   *
   * 2 = Apple
   *
   * 3 = Tenovi
   *
   * 4 = Life365
   */
  VendorType: DeviceVendorType
  DeviceId: string
  IsDisabled: boolean
  /** @format int32 */
  UserId?: number | null
  ProgramId: string
  /**
   *
   *
   * 10 = BPM
   *
   * 11 = PulseOx
   *
   * 12 = Glucometer
   *
   * 13 = Scale
   *
   * 14 = Thermometer
   *
   * 15 = Watch
   *
   * 17 = PeakFlowMeter
   */
  TenoviSensorCodeType?: TenoviSensorCode
}

export interface Life365DeviceStatusModel {
  TabletId: string
  /** @format int32 */
  BatteryLife: number
  OnCharger: boolean
  /** @format date-time */
  DeviceTime: string
}

export interface Life365ProgramModel {
  Name: string
  Id: string
}

/**
 *
 *
 * 1 = Temperature
 *
 * 2 = BloodPressureSystolic
 *
 * 3 = BloodPressureDiastolic
 *
 * 4 = GlucoseLevel
 *
 * 5 = Pulse
 *
 * 6 = OxygenSaturation
 *
 * 7 = Weight
 *
 * 8 = Height
 *
 * 9 = RestingPulse
 *
 * 10 = PerfusionIndex
 *
 * 11 = PeakExpiratoryFlow
 *
 * 12 = ForcedExpiratoryVolume
 * @format int32
 */
export enum MeasureType {
  Temperature = 1,
  BloodPressureSystolic = 2,
  BloodPressureDiastolic = 3,
  GlucoseLevel = 4,
  Pulse = 5,
  OxygenSaturation = 6,
  Weight = 7,
  Height = 8,
  RestingPulse = 9,
  PerfusionIndex = 10,
  PeakExpiratoryFlow = 11,
  ForcedExpiratoryVolume = 12,
}

export interface MeasureTypeToUnitModel {
  /**
   *
   *
   * 1 = Temperature
   *
   * 2 = BloodPressureSystolic
   *
   * 3 = BloodPressureDiastolic
   *
   * 4 = GlucoseLevel
   *
   * 5 = Pulse
   *
   * 6 = OxygenSaturation
   *
   * 7 = Weight
   *
   * 8 = Height
   *
   * 9 = RestingPulse
   *
   * 10 = PerfusionIndex
   *
   * 11 = PeakExpiratoryFlow
   *
   * 12 = ForcedExpiratoryVolume
   */
  MeasureId: MeasureType
  /**
   *
   *
   * 1 = DegreesCelsius
   *
   * 2 = DegreesFahrenheit
   *
   * 3 = BeatsPerMinute
   *
   * 4 = MillimetersOfMercury
   *
   * 5 = Percentage
   *
   * 6 = MillimolesPerLiter
   *
   * 7 = Kilogram
   *
   * 8 = Pound
   *
   * 9 = Foot
   *
   * 10 = Inch
   *
   * 11 = Meter
   *
   * 12 = Centimeter
   *
   * 13 = MilligramsPerDeciliter
   *
   * 14 = LitersPerMinute
   *
   * 15 = Liters
   */
  MeasureUnitId: MeasureUnitsType
}

/**
 *
 *
 * 1 = DegreesCelsius
 *
 * 2 = DegreesFahrenheit
 *
 * 3 = BeatsPerMinute
 *
 * 4 = MillimetersOfMercury
 *
 * 5 = Percentage
 *
 * 6 = MillimolesPerLiter
 *
 * 7 = Kilogram
 *
 * 8 = Pound
 *
 * 9 = Foot
 *
 * 10 = Inch
 *
 * 11 = Meter
 *
 * 12 = Centimeter
 *
 * 13 = MilligramsPerDeciliter
 *
 * 14 = LitersPerMinute
 *
 * 15 = Liters
 * @format int32
 */
export enum MeasureUnitsType {
  DegreesCelsius = 1,
  DegreesFahrenheit = 2,
  BeatsPerMinute = 3,
  MillimetersOfMercury = 4,
  Percentage = 5,
  MillimolesPerLiter = 6,
  Kilogram = 7,
  Pound = 8,
  Foot = 9,
  Inch = 10,
  Meter = 11,
  Centimeter = 12,
  MilligramsPerDeciliter = 13,
  LitersPerMinute = 14,
  Liters = 15,
}

/**
 *
 *
 * 1 = asc
 *
 * 2 = desc
 * @format int32
 */
export enum SortingOrder {
  Asc = 1,
  Desc = 2,
}

/**
 *
 *
 * 1 = TenoviBpmS
 *
 * 2 = TenoviBpmSSignature
 *
 * 3 = TenoviBpmL
 *
 * 4 = TenoviBpmLSignature
 *
 * 5 = TenoviPulseOx
 *
 * 6 = TenoviScale
 *
 * 7 = TenoviGlucometer
 *
 * 8 = TenoviWatch
 * @format int32
 */
export enum TenoviDeviceNameType {
  TenoviBpmS = 1,
  TenoviBpmSSignature = 2,
  TenoviBpmL = 3,
  TenoviBpmLSignature = 4,
  TenoviPulseOx = 5,
  TenoviScale = 6,
  TenoviGlucometer = 7,
  TenoviWatch = 8,
}

export interface TenoviMeasurementModel {
  /**
   *
   *
   * 1 = BloodPressure
   *
   * 2 = Pulse
   *
   * 3 = SpO2
   *
   * 4 = PerfusionIndex
   *
   * 5 = Weight
   *
   * 6 = Temperature
   *
   * 7 = Glucose
   *
   * 8 = PeakExpiratoryFlow
   *
   * 9 = ForcedExpiratoryVolume
   *
   * 10 = BatteryPercentage
   */
  Metric: TenoviMetricType
  DeviceName: string
  HwiDeviceId: string
  PatientId: string
  HardwareUuid: string
  /**
   *
   *
   * 10 = BPM
   *
   * 11 = PulseOx
   *
   * 12 = Glucometer
   *
   * 13 = Scale
   *
   * 14 = Thermometer
   *
   * 15 = Watch
   *
   * 17 = PeakFlowMeter
   */
  SensorCode: TenoviSensorCode
  /** @format double */
  Value1: number
  /** @format double */
  Value2?: number | null
  /** @format date-time */
  Created: string
  /** @format date-time */
  Timestamp: string
  /** @format int32 */
  TimezoneOffset: number
  EstimatedTimestamp: boolean
}

/**
 *
 *
 * 1 = BloodPressure
 *
 * 2 = Pulse
 *
 * 3 = SpO2
 *
 * 4 = PerfusionIndex
 *
 * 5 = Weight
 *
 * 6 = Temperature
 *
 * 7 = Glucose
 *
 * 8 = PeakExpiratoryFlow
 *
 * 9 = ForcedExpiratoryVolume
 *
 * 10 = BatteryPercentage
 * @format int32
 */
export enum TenoviMetricType {
  BloodPressure = 1,
  Pulse = 2,
  SpO2 = 3,
  PerfusionIndex = 4,
  Weight = 5,
  Temperature = 6,
  Glucose = 7,
  PeakExpiratoryFlow = 8,
  ForcedExpiratoryVolume = 9,
  BatteryPercentage = 10,
}

/**
 *
 *
 * 10 = BPM
 *
 * 11 = PulseOx
 *
 * 12 = Glucometer
 *
 * 13 = Scale
 *
 * 14 = Thermometer
 *
 * 15 = Watch
 *
 * 17 = PeakFlowMeter
 * @format int32
 */
export enum TenoviSensorCode {
  BPM = 10,
  PulseOx = 11,
  Glucometer = 12,
  Scale = 13,
  Thermometer = 14,
  Watch = 15,
  PeakFlowMeter = 17,
}

export interface UpdateDeviceRequest {
  /** @format int32 */
  Id: number
  /** @maxLength 100 */
  ExternalId: string
  /** @maxLength 100 */
  Name: string
  IsDisabled: boolean
}

export interface UserHealthChartsStateModel {
  /** @format int32 */
  PatientId: number
  /** @format int32 */
  PatientTenantId: number
  HealthInfoSetting?: string | null
}

export type AddAsyncPayload = AddMeasuresRequest[]

export type PostMeasurementPayload = TenoviMeasurementModel[]

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staginghealth/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Health devices api
 * @baseUrl https://api-dev.collaborate.center/staginghealth/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  healthData = {
    /**
     * No description
     *
     * @tags HealthData
     * @name AddAsync
     * @request POST:/health-device-service/api/healthData/v2
     */
    addAsync: (data: AddAsyncPayload, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/health-device-service/api/healthData/v2`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthData
     * @name GetAllAsync
     * @request GET:/health-device-service/api/healthData/v2
     */
    getAllAsync: (
      query: {
        /** @format int32 */
        PatientId: number
        /** @format int32 */
        TenantId: number
        MeasureModels: MeasureTypeToUnitModel[]
        /** @format int32 */
        ContentId?: number
        /** @format date-time */
        StartTime?: string
        /** @format date-time */
        EndTime?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetMeasureResponse[], ApiErrorResponse>({
        path: `/health-device-service/api/healthData/v2`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthData
     * @name GetLatestAsync
     * @request GET:/health-device-service/api/healthData/v2/latest
     */
    getLatestAsync: (
      query?: {
        measureModels?: MeasureTypeToUnitModel[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetMeasureResponse[], ApiErrorResponse>({
        path: `/health-device-service/api/healthData/v2/latest`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthData
     * @name GetLastHealthDataUpdateAsync
     * @request GET:/health-device-service/api/healthData/v2/lastHealthDataUpdate
     */
    getLastHealthDataUpdateAsync: (
      query: {
        /**
         *
         *
         * 1 = MultiPurposeHealthDevice
         *
         * 2 = Thermometer
         *
         * 3 = PressureMonitor
         *
         * 4 = SugarMonitor
         *
         * 5 = Pulsemeter
         *
         * 6 = PulseOximeter
         *
         * 7 = Scale
         *
         * 8 = Stadiometer
         *
         * 9 = PeakFlowMeter
         *
         * 10 = Spirometer
         */
        CategoryType: DeviceCategoryType
        /**
         *
         *
         * 1 = Google
         *
         * 2 = Apple
         *
         * 3 = Tenovi
         *
         * 4 = Life365
         */
        VendorType: DeviceVendorType
        /** @format uuid */
        UserGuid?: string
        /**
         *
         *
         * 1 = Temperature
         *
         * 2 = BloodPressureSystolic
         *
         * 3 = BloodPressureDiastolic
         *
         * 4 = GlucoseLevel
         *
         * 5 = Pulse
         *
         * 6 = OxygenSaturation
         *
         * 7 = Weight
         *
         * 8 = Height
         *
         * 9 = RestingPulse
         *
         * 10 = PerfusionIndex
         *
         * 11 = PeakExpiratoryFlow
         *
         * 12 = ForcedExpiratoryVolume
         */
        MeasureTypeId: MeasureType
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/health-device-service/api/healthData/v2/lastHealthDataUpdate`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthData
     * @name AddUserHealthChartsStateAsync
     * @request POST:/health-device-service/api/healthData/v2/userHealthChartsState
     */
    addUserHealthChartsStateAsync: (data: UserHealthChartsStateModel, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/health-device-service/api/healthData/v2/userHealthChartsState`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthData
     * @name GetUserHealthChartsStateAsync
     * @request GET:/health-device-service/api/healthData/v2/userHealthChartsState
     */
    getUserHealthChartsStateAsync: (
      query: {
        /** @format int32 */
        PatientId: number
        /** @format int32 */
        PatientTenantId: number
        HealthInfoSetting?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserHealthChartsStateModel, ApiErrorResponse>({
        path: `/health-device-service/api/healthData/v2/userHealthChartsState`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  healthDevice = {
    /**
     * No description
     *
     * @tags HealthDevice
     * @name GetAllMyAsync
     * @request GET:/health-device-service/api/HealthDevice/my
     */
    getAllMyAsync: (params: RequestParams = {}) =>
      this.http.request<GetDeviceResponse[], ApiErrorResponse>({
        path: `/health-device-service/api/HealthDevice/my`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthDevice
     * @name GetByUserIdAsync
     * @request GET:/health-device-service/api/HealthDevice/{userId}
     */
    getByUserIdAsync: (
      userId: number,
      query?: {
        /** @format int32 */
        contentId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetDeviceResponse[], ApiErrorResponse>({
        path: `/health-device-service/api/HealthDevice/${userId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthDevice
     * @name GetAsync
     * @request GET:/health-device-service/api/HealthDevice/all
     */
    getAsync: (
      query?: {
        /** @format int32 */
        PageNumber?: number
        /** @format int32 */
        PageSize?: number
        'SortModel.ColumnName'?: string
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'SortModel.Order'?: SortingOrder
        'FilterModel.ExternalId'?: string
        'FilterModel.Name'?: string
        'FilterModel.DeviceCategory'?: DeviceCategoryType[]
        'FilterModel.DeviceVendor'?: DeviceVendorType[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/health-device-service/api/HealthDevice/all`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthDevice
     * @name CreateAsync
     * @request POST:/health-device-service/api/HealthDevice
     */
    createAsync: (data: CreateDeviceRequest, params: RequestParams = {}) =>
      this.http.request<IOTDeviceViewModel, ApiErrorResponse>({
        path: `/health-device-service/api/HealthDevice`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthDevice
     * @name PutAsync
     * @request PUT:/health-device-service/api/HealthDevice
     */
    putAsync: (data: UpdateDeviceRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/health-device-service/api/HealthDevice`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthDevice
     * @name DeleteAsync
     * @request DELETE:/health-device-service/api/HealthDevice
     */
    deleteAsync: (
      query?: {
        /** @format int32 */
        id?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/health-device-service/api/HealthDevice`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthDevice
     * @name GetDeviceTypesAsync
     * @request GET:/health-device-service/api/HealthDevice/deviceTypes
     */
    getDeviceTypesAsync: (params: RequestParams = {}) =>
      this.http.request<GetDeviceTypesResponse[], ApiErrorResponse>({
        path: `/health-device-service/api/HealthDevice/deviceTypes`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  iotDevice = {
    /**
     * No description
     *
     * @tags IOTDevice
     * @name GetAsync
     * @request GET:/health-device-service/api/IOTDevice/{id}
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/health-device-service/api/IOTDevice/${id}`,
        method: 'GET',
        ...params,
      }),
  }
  life365 = {
    /**
     * No description
     *
     * @tags Life365
     * @name LoginAsync
     * @request GET:/health-device-service/api/Life365/login
     */
    loginAsync: (params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/health-device-service/api/Life365/login`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Life365
     * @name GetListOfProgramsAsync
     * @request GET:/health-device-service/api/Life365/listOfPrograms
     */
    getListOfProgramsAsync: (params: RequestParams = {}) =>
      this.http.request<Life365ProgramModel[], ApiErrorResponse>({
        path: `/health-device-service/api/Life365/listOfPrograms`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Life365
     * @name GetAssignedLife365DeviceStatusAsync
     * @request GET:/health-device-service/api/Life365/assignedLife365DeviceStatus
     */
    getAssignedLife365DeviceStatusAsync: (params: RequestParams = {}) =>
      this.http.request<Life365DeviceStatusModel, ApiErrorResponse>({
        path: `/health-device-service/api/Life365/assignedLife365DeviceStatus`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Life365
     * @name ClearLife365DeviceAsync
     * @request POST:/health-device-service/api/Life365/clearLife365Device
     */
    clearLife365DeviceAsync: (data: ClearLife365DeviceModel, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/health-device-service/api/Life365/clearLife365Device`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  measures = {
    /**
     * No description
     *
     * @tags Measures
     * @name GetMy
     * @request GET:/health-device-service/api/Measures
     */
    getMy: (
      query: {
        /**
         *
         *
         * 1 = Temperature
         *
         * 2 = BloodPressureSystolic
         *
         * 3 = BloodPressureDiastolic
         *
         * 4 = GlucoseLevel
         *
         * 5 = Pulse
         *
         * 6 = OxygenSaturation
         *
         * 7 = Weight
         *
         * 8 = Height
         *
         * 9 = RestingPulse
         *
         * 10 = PerfusionIndex
         *
         * 11 = PeakExpiratoryFlow
         *
         * 12 = ForcedExpiratoryVolume
         */
        measureType: MeasureType
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/health-device-service/api/Measures`,
        method: 'GET',
        query: query,
        ...params,
      }),
  }
  tenovi = {
    /**
     * No description
     *
     * @tags Tenovi
     * @name PostMeasurement
     * @request POST:/health-device-service/api/Tenovi/measurement
     */
    postMeasurement: (data: PostMeasurementPayload, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/health-device-service/api/Tenovi/measurement`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
}
